import { DokaImageEditor } from "react-doka";
import { Modal } from "semantic-ui-react";
import { editorConfig } from "../../../utils/DokaConfig";

const CropFeature = (props) => {
  const handleImageEvent = (type) => {
    if (type === "loadabort") {
      props.close();
    }
    if (type === "close") {
      props.close();
    }
  };

  return (
    <Modal
      onClose={() => {
        props.close();
      }}
      open={props.open}
    >
      <div className="AdminEditImageContainer">
        <Modal.Content>
          {props.imgSrc && (
            <div className="AdminImageEditorContainer">
              <DokaImageEditor
                {...editorConfig}
                src={URL.createObjectURL(props.imgSrc)}
                // enableButtonClose={true}
                handleEvent={(type) => handleImageEvent(type)}
                imageCropAspectRatio={3 / 2}
                onProcess={({ dest }) => {
                  props.getCroppedImage(dest);
                  props.close();
                }}
              />
            </div>
          )}
        </Modal.Content>
      </div>
    </Modal>
  );
};

export default CropFeature;
